import { AnimalsWithTags } from "./types";

export const animalsWithTags = (selectedAnimals: AnimalsWithTags, id?: string) =>
  (selectedAnimals ?? []).filter((animal) => animal?.node?.tags?.some((tag) => tag.tagId === id));

export const animalsWithoutTags = (selectedAnimals: AnimalsWithTags, tagIdToCheck?: string) =>
  (selectedAnimals ?? []).filter((animal) => {
    return !animal?.node?.tags?.some((tag) => tag.tagId === tagIdToCheck);
  });
